var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-editor',{ref:"editor",staticClass:"dark-theme",attrs:{"disabled":_vm.schema.readonly,"editor-toolbar":_vm.toolbarOptions},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }